import React, { useState } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,

  // Search
  search,
  setSearch,

  // Filters
  filters,
  onApplyFilters,
  onClearFilters,

  // Pagination
  currentPage,
  totalRows,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  return (
    <div className="table-responsive">
      {/* =====================================================
          SEARCH + FILTER
      ====================================================== */}

      <div className="row justify-content-between mb-2">
        {/* Search */}

        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder="Search by Asset Name or User"
            className="form-control"
            value={search || ""}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Filter */}

        <div className="col-md-9 mb-2">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {/* =====================================================
          DATA TABLE
      ====================================================== */}

      {apidata && apidata.length > 0 ? (
        <DataTable
          columns={columns}
          data={apidata}
          /* Server-side pagination */
          pagination
          paginationServer
          paginationTotalRows={totalRows || 0}
          paginationDefaultPage={currentPage || 1}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          paginationPerPage={rowsPerPage || 10}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
          /* UI */

          fixedHeader
          fixedHeaderScrollHeight="500px"
          highlightOnHover
          responsive
          persistTableHead
          noDataComponent="No Assets Found"
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p className="text-muted mb-0">No assets found.</p>
          </div>
        </div>
      )}

      {/* =====================================================
          FILTER MODAL
      ====================================================== */}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        filters={filters}
        onApplyFilters={(newFilters) => {
          onApplyFilters(newFilters);
          setShowFilterModal(false);
        }}
        onClearFilters={() => {
          onClearFilters();
          setShowFilterModal(false);
        }}
      />
    </div>
  );
}
